module.exports = __webpack_public_path__ + "static/media/avar-smile.acfe5e80.png";